<template>
  <v-card
    outlined
    elevation="1"
    :class="positionStyle"
  >
    <v-list-item class="px-2">
      <v-list-item-avatar size="50" color="white">
        <v-img :src="post.logo_url" />
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title v-text="post.page_name" />
        <v-list-item-subtitle v-text="timeAgo" />
      </v-list-item-content>

      <v-list-item-action class="my-0">
        <div class="d-flex flex-column align-center">
          <v-btn icon>
            <v-icon
              @click="sharePost"
              color="grey"
              title="Share this post"
              small
            >
              fa-share-alt
            </v-icon>
          </v-btn>
          <v-list-item-action-text v-if="showRanking">
            <div class="d-flex align-center">
              <div class="text-caption">#</div>
              <div class="text-h6">
                {{ parseInt(hofRanking + 1) }}
              </div>
            </div>
          </v-list-item-action-text>
        </div>
      </v-list-item-action>
    </v-list-item>
    <v-snackbar v-model="snackbar" :vertical="vertical">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-divider class="my-0" />
    <v-card-text class="text--primary text-body-1">
      <VueReadMoreSmooth :lines="7" :g-lines="4">
        <!-- this has to be one line or the white-space styling will render the newlines as written -->
        <div style="paddingBottom: '10px'; white-space: pre-line;">{{ post.text.trim() }}</div>
      </VueReadMoreSmooth>
    </v-card-text>
    <v-card-text v-if="post.image_url">
      <v-row justify="center">
        <v-img
          :src="post.image_url"
          contain
          :max-width="imageWidth"
          :max-height="imageHeight"
          @click.stop="largeImage = !largeImage"
        />
      </v-row>
    </v-card-text>
    <v-divider class="my-0"/>
    <v-card-actions>
      <template v-for="(reaction, i) in reactions">
        <v-col v-if="reaction.name !== 'total'" :key="i" :style="{ color: reaction.colour }">
          <v-row justify="center" align="center">
            <v-avatar tile size="15" class="mr-1">
              <img :src="reaction.path" />
            </v-avatar>
            {{ kFormatter(post[`react_${reaction.name}_count`]) }}
          </v-row>
        </v-col>
      </template>
    </v-card-actions>
  </v-card>
</template>
<script>
import VueReadMoreSmooth from "vue-read-more-smooth";
import moment from "moment";

export default {
  data: () => ({
    snackbar: false,
    text: "Copied post link to clipboard",
    vertical: true,
    largeImage: false,
  }),
  props: {
    post: Object,
    hofRanking: Number | String,
    logoUrl: String,
    reactions: Object,
    pageHofUrl: String,
    showRanking: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    VueReadMoreSmooth,
  },
  computed: {
    imageWidth() {
      return this.largeImage ? "100%" : "50%";
    },
    imageHeight() {
      return this.largeImage ? "100%" : "200px";
    },
    positionStyle() {
      const styles = ["gold", "silver", "bronze"];
      return styles[this.hofRanking] ? styles[this.hofRanking] : "";
    },
    timeAgo() {
      const time = moment(this.post.time_posted);
      return moment(time).fromNow();
    }
  },
  methods: {
    kFormatter(num) {
      num ??= 0;
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },
    sharePost() {
      if (navigator.share) {
        navigator
          .share({
            title: `The #${this.hofRanking} post on ${this.post.page_name}`,
            text: this.post.text,
            url: this.post.hall_of_fame_url,
          })
          .then(() => console.log("Successful share"))
          .catch((error) => console.log("Error sharing", error));
      } else {
        navigator.clipboard.writeText(this.post.hall_of_fame_url);
        this.snackbar = true;
      }
    },
  },
};
</script>
<style scoped>
.gold {
  background: linear-gradient(#fff2a9 0%, white 40%);
}
.silver {
  background: linear-gradient(#dcdcdc 0%, white 40%);
}
.bronze {
  background: linear-gradient(#eaccaf 0%, white 40%);
}
.read-more-button {
  padding: 1rem !important;
  margin: 0 !important;
  border-top: none !important;
}
.button-read-more {
  background: rgb(255, 255, 255);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.648879620207458) 10%,
    rgba(255, 255, 255, 1) 100%
  );
}
</style>
